import React, { useCallback, useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const getClasses = (active) => {
  let cls = "cursor";
  if (!!active) cls = cls + " cursor-active";
  if (active === "telegram") cls = cls + " cursor-active--telegram";
  if (active === "instagram") cls = cls + " cursor-active--inst";
  return cls;
};

export default function Cursor({ active, isActiveInst, isActiveTelegram }) {
  const [cursorXY, setCursorXY] = useState({ x: -100, y: -100 });

  const moveCursor = useCallback(
    (e) => {
      const x = e.clientX - (active ? 50 : 25);
      const y = e.clientY - (active ? 50 : 25);
      setCursorXY({ x, y });
    },
    [active],
  );

  useEffect(() => {
    window.addEventListener("mousemove", moveCursor);

    return () => window.removeEventListener("mousemove", moveCursor);
  }, [moveCursor]);

  return <div className={getClasses(active)} style={{ transform: `translate3d(${cursorXY.x}px, ${cursorXY.y}px, 0)` }} />;
}
